import { Component, OnInit, AfterViewInit,HostListener, ViewChild, TemplateRef, ViewContainerRef, ViewChildren, QueryList} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-new-line',
  templateUrl: './new-line.component.html',
  styleUrls: ['./new-line.component.scss']
})
export class NewLineComponent implements OnInit {

  step : any;

  @ViewChildren('step', {read: TemplateRef}) private _stepList: QueryList<TemplateRef<any>>

  constructor(private store:Store<any>, private vcRef: ViewContainerRef) {
    store.subscribe(store =>{
      this.step = store.mainCampaign.step; 
      this.vcRef.clear();
      if(this._stepList) {
        this.vcRef.createEmbeddedView(this._stepList.toArray()[this.step - 1])
      }
    }) 

   }
  ngOnInit() {
  }

}
